<template>
  <div>
    <gg-card class="mb-12">
      <gg-card-header>
        Home Page Section
      </gg-card-header>
      <gg-card-text>
        <v-row>
          <v-col cols="12">
            <p>
              Please provide the content that you would like to place on your website’s home page.
            </p>
            <v-textarea label="Provide content for Your Website's Home Section"
                        v-model="contentHome"
                        rows="4"
                        name="content-home"
                        outlined
                        autocomplete="new-password"
                        data-vv-as="Home Section Content"
                        :error-messages="errors.collect('content-home')"></v-textarea>
          </v-col>
        </v-row>
      </gg-card-text>
    </gg-card>

    <gg-card class="mb-12">
      <gg-card-header>
        About Us Section
      </gg-card-header>
      <gg-card-text>
        <v-row>
          <v-col cols="12">
            <p>
              Please provide the content that you would like to place on your website’s about us page.
            </p>
            <v-textarea label="Provide content for Your Website's About Section"
                        v-model="contentAbout"
                        rows="4"
                        name="content-about"
                        outlined
                        autocomplete="new-password"
                        data-vv-as="About Section Content"
                        :error-messages="errors.collect('content-about')"
                        :hint="`${contentAboutLength.wordsAvailable} words left out of ${contentAboutLength.maxWordsNumber} possible`"
            ></v-textarea>
          </v-col>
        </v-row>
      </gg-card-text>
    </gg-card>

    <gg-card class="mb-12">
      <gg-card-header>
        Products & Services
      </gg-card-header>
      <gg-card-text>
        <v-row>
          <v-col cols="12">
            <p>
              Please provide up to 6 products and services.
            </p>
            <template v-for="(service, index) in services">
              <v-textarea label="Provide content for Your Website's Services or Products Section"
                          :key="`service-${index}`"
                          v-model="services[index]"
                          rows="4"
                          :name="`content-services${index}`"
                          outlined
                          autocomplete="new-password"
                          data-vv-as="Services Section Content"
                          :error-messages="errors.collect(`content-services${index}`)"></v-textarea>
            </template>
            <gg-btn v-if="canAddService" text @click="addServiceProduct">
              Add Item
            </gg-btn>
          </v-col>
        </v-row>
      </gg-card-text>
    </gg-card>

    <gg-card class="mb-12">
      <gg-card-header>
        Your Business Location
      </gg-card-header>
      <gg-card-text>
        <v-row>
          <v-col cols="12">
            <gg-text-field label="Your Business Address"
                          v-model="businessAddress"
                          name="address"
                          outlined
                          autocomplete="new-password"
                          data-vv-as="Business Address"
                          :error-messages="errors.collect('address')" />
            <v-row>
              <v-col cols="12" md="6">
                <gg-text-field label="City"
                              v-model="city"
                              name="city"
                              outlined
                              autocomplete="new-password"
                              data-vv-as="City"
                              :error-messages="errors.collect('city')" />
              </v-col>
              <v-col cols="12" md="6">
                <gg-text-field label="Zipcode"
                              v-model="zipcode"
                              name="zipcode"
                              outlined
                              autocomplete="new-password"
                              data-vv-as="Zipcode"
                              :error-messages="errors.collect('zipcode')" />
              </v-col>
            </v-row>
            <gg-select v-model="country"
                      label="Select Your Country"
                      name="country"
                      outlined
                      :items="countries"
                      item-text="name"
                      item-value="name"
                      data-vv-as="Country"
                      :error-messages="errors.collect('country')" />
            <gg-text-field label="Provide the Company Email Address"
                          v-model="email"
                          name="email"
                          outlined
                          autocomplete="new-password"
                          data-vv-as="Email Address"
                          v-validate="'email'"
                          :error-messages="errors.collect('email')" />
            <gg-text-field label="Provide the Company Phone Number"
                          v-model="phone"
                          name="phone"
                          outlined
                          autocomplete="new-password"
                          data-vv-as="Phone Number"
                          v-validate="'phone'"
                          :error-messages="errors.collect('phone')" />
          </v-col>
        </v-row>
      </gg-card-text>
    </gg-card>

    <gg-card class="mt-6">
      <gg-card-header>
        Business Hours
      </gg-card-header>
      <gg-card-text>
        <v-row>
          <v-col cols="12">
            <v-form>
              <v-switch v-model="businessHours"
                        :true-value="1"
                        :false-value="0"
                        label="My business has hours"></v-switch>
            </v-form>
            <work-schedule v-if="businessHours"></work-schedule>
          </v-col>
        </v-row>
      </gg-card-text>
    </gg-card>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { countries } from '@/helpers/countries'
import WorkSchedule from './WorkSchedule'

const phoneValidator = {
  getMessage (field) {
    return `The ${field} must be a valid phone number`
  },
  validate (val) {
    const phoneRegex = /^\(?([0-9]{0,3})\)?([ .-]?)([0-9]{3})\2([0-9]{4,6})$/
    return phoneRegex.test(val)
  }
}

export default {
  name: 'WebsiteInformation',
  components: {
    WorkSchedule,
  },
  data () {
    return {
      countries,
      maxServices: 6,
      services: ['', '', ''],
    }
  },
  computed: {
    ...mapGetters({
      model: 'wizard_model/starterSite'
    }),
    contentHome: {
      get () {
        return this.model.contentHome
      },
      set (val) {
        this.setCHome(val)
      }
    },
    contentAbout: {
      get () {
        return this.model.contentAbout
      },
      set (val) {
        this.setAbout(val)
      }
    },
    businessHours: {
      get () {
        return this.model.businessHours
      },
      set (val) {
        this.setBusinessHours(val)
      },
    },
    businessAddress: {
      get () {
        return this.model.businessAddress
      },
      set (val) {
        this.setAddress(val)
      },
    },
    city: {
      get () {
        return this.model.city
      },
      set (val) {
        this.setCity(val)
      },
    },
    zipcode: {
      get () {
        return this.model.zipcode
      },
      set (val) {
        this.setZip(val)
      },
    },
    country: {
      get () {
        return this.model.country
      },
      set (val) {
        this.setCountry(val)
      },
    },
    email: {
      get () {
        return this.model.companyEmail
      },
      set (val) {
        this.setCompanyEmail(val)
      },
    },
    phone: {
      get () {
        return this.model.companyPhone
      },
      set (val) {
        this.setCompanyPhone(val)
      },
    },
    canAddService () {
      return this.services.length < this.maxServices
    },
    contentAboutLength () {
      const arrayOfWords = this.contentAbout.trim().split(' ')
      const MAX_WORD_NUMBER = 250

      return {
        maxWordsNumber: MAX_WORD_NUMBER,
        wordsAvailable: MAX_WORD_NUMBER - arrayOfWords.length,
      }
    }
  },
  methods: {
    ...mapMutations({
      setCHome: 'wizard_model/SET_SS_CONTENT_HOME',
      setAbout: 'wizard_model/SET_SS_CONTENT_ABOUT',
      setServices: 'wizard_model/SET_SS_CONTENT_SERVICES',
      setAddress: 'wizard_model/SET_SS_BUSINESS_ADDRESS',
      setCity: 'wizard_model/SET_SS_CITY',
      setZip: 'wizard_model/SET_SS_ZIPCODE',
      setCountry: 'wizard_model/SET_SS_COUNTRY',
      setCompanyEmail: 'wizard_model/SET_SS_COMPANY_EMAIL',
      setCompanyPhone: 'wizard_model/SET_SS_COMPANY_PHONE',
      setBusinessHours: 'wizard_model/SET_SS_BUSINESS_HOURS',
    }),
    async validate () {
      return this.$validator.validateAll()
    },
    addServiceProduct () {
      if (!this.canAddService) return
      this.services.push('')
    }
  },
  watch: {
    services: {
      handler (val) {
        this.setServices(val)
      },
      deep: true,
    },
    contentAbout: {
      handler (val) {
        let words = val.split(' ')

        if (words.filter(Boolean).length > 250) {
          const text = val.split(' ').slice(0, 250).join(' ')

          this.setAbout(text)
        }
      }
    }
  },
  mounted () {
    this.$validator.extend('phone', phoneValidator)
  },
}
</script>
